import * as React from 'react'
import { memo } from 'react'
const SvgChevronDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 4">
    <path d="M3 4 0 0h6Z" />
  </svg>
)
const Memo = memo(SvgChevronDown)
export default Memo
